import ReactQuill from 'react-quill';

const Toolbar = ReactQuill.Quill.import('modules/toolbar');

class ToolbarAlt extends Toolbar {
  resetToolbar() {
    this.container.childNodes.forEach(el => {
      const clone = el.cloneNode(true);
      el.parentNode.replaceChild(clone, el);
    });
    this.container.childNodes.forEach(input => {
      this.attach(input);
    }, this);
  }
}

export default ToolbarAlt;
